<div class="hunt-details-editor-wrapper">
  <div class="title">
    <hyperkit-typography [variant]="variant">{{ title }}</hyperkit-typography>
  </div>
  <hyperkit-editor
    [height]="height"
    [value]="value"
    (valueChange)="onEditorValueChange($event)"
  ></hyperkit-editor>
</div>
